import { createDCHook, collapseDataFromCall } from '../../client';
import { getOverview } from '../../services/smartthermostat/SupportService';

export const useSupportGetOverview = createDCHook('getOverview', collapseDataFromCall(getOverview), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
